import { Component, Input, OnInit, OnChanges } from '@angular/core'

@Component({
    template: `
        <nb-user
            size="{{ size || 'large' }}"
            name="{{ tmpName || '' }}"
            picture="{{ tmpAvatar | ImageUrlPipe }}"
        ></nb-user>
    `,
    selector: 'app-avatar',
})
export class PvsAvatarComponent implements OnInit, OnChanges {
    @Input() avatarUrl: string
    @Input() name: string | number
    @Input() size: string
    @Input() user: any
    DEFAULT_AVATAR = 'general%2Fdefault_user_avatar_1.png'
    tmpAvatar: string
    tmpName: string

    ngOnInit() {
        this.mapData()
    }

    ngOnChanges() {
        this.mapData()
    }

    mapData() {
        this.tmpAvatar = this.avatarUrl || this.user?.avatarUrl || this.DEFAULT_AVATAR
        this.tmpName = this.name?.toString()
        if (!this.tmpName && !!this.user) {
            this.tmpName = (this.user.firstName + ' ' + this.user.lastName)?.trim()
        }
    }
}
